import { render, staticRenderFns } from "./ExGenericSelector.vue?vue&type=template&id=20658d1b&scoped=true"
import script from "./ExGenericSelector.vue?vue&type=script&lang=js"
export * from "./ExGenericSelector.vue?vue&type=script&lang=js"
import style1 from "./ExGenericSelector.vue?vue&type=style&index=1&id=20658d1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20658d1b",
  null
  
)

export default component.exports